module.exports = __webpack_public_path__ + "static/media/microcontroller.33f0bbe5.jpg";